module.exports = __webpack_public_path__ + "img/imagen-reciclaje.9ccdb9b3.png";